// Trace columns as /demo/metrics-face-asymmetry shows them. Pure functions; the
// trace itself is never changed.
//
// Smile: the mouth width plot becomes each patient side's share of the width
// (width_share_patient_left/right, the mouth_width_share group in traceSeries),
// and the mouth height to width plot is dropped. The dropped columns are removed, so
// none of them comes back as an "unknown number" plot. The per-frame checks
// (mouth_round_ok, …) stay.

export const SMILE_SLUG = 'smiley-face';

const WIDTH_COLUMNS = ['mouth_width', 'mouth_width_needed', 'mouth_width_left', 'mouth_width_right'];
const ROUND_COLUMNS = ['mouth_round', 'mouth_round_max', 'mouth_round_min', 'mouth_round_left', 'mouth_round_right'];

const present = (v) => v !== null && v !== undefined;

/**
 * Per frame: left / (left + right) and right / (left + right), by the sides as the
 * columns name them (image sides); null if a side is missing or the sum is not > 0.
 */
export function widthShare(left, right) {
  const shares = { left: [], right: [] };
  for (let i = 0; i < left.length; i += 1) {
    const l = left[i];
    const r = right[i];
    const sum = l + r;
    const ok = present(l) && present(r) && sum > 0;
    shares.left.push(ok ? l / sum : null);
    shares.right.push(ok ? r / sum : null);
  }
  return shares;
}

/**
 * The columns to plot. For a smile the width shares replace the width columns
 * and mouth roundness is removed. When the exercise is unknown, the same is
 * done if the trace has both width sides; any other exercise is returned as it is.
 */
export function asymmetryColumns(columns, exerciseSlug) {
  const { mouth_width_left: left, mouth_width_right: right } = columns;
  const hasSides = Array.isArray(left) && Array.isArray(right);
  if (exerciseSlug ? exerciseSlug !== SMILE_SLUG : !hasSides) return columns;
  const out = { ...columns };
  [...WIDTH_COLUMNS, ...ROUND_COLUMNS].forEach((name) => delete out[name]);
  // without both sides there is no share to show
  if (hasSides) {
    // The CV module's *_left columns are IMAGE-left. The session video is the raw,
    // unmirrored camera frame, so image left is the patient's anatomical RIGHT:
    // the patient's left share comes from mouth_width_right, and vice versa.
    const shares = widthShare(left, right);
    out.width_share_patient_left = shares.right;
    out.width_share_patient_right = shares.left;
  }
  return out;
}
